import { motion } from "framer-motion";
import { Shield, FileCheck, Lock } from "lucide-react";

const trustBadges = [
  { icon: Shield, label: "Verificado SAT" },
  { icon: FileCheck, label: "CFDI 4.0" },
  { icon: Lock, label: "SSL Security" },
];

const stats = [
  { value: "800+", label: "clientes activos" },
  { value: "5,000+", label: "declaraciones presentadas" },
  { value: "95%", label: "satisfacción" },
];

export function TrustSection() {
  return (
    <section className="py-12 border-y border-border/50 bg-muted/30">
      <div className="container-custom">
        <div className="flex flex-col lg:flex-row items-center justify-between gap-8">
          {/* Trust Badges */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="flex flex-wrap items-center justify-center gap-8"
          >
            <span className="text-sm text-muted-foreground font-medium">Confían en nosotros:</span>
            {trustBadges.map((badge, i) => (
              <div key={i} className="flex items-center gap-2 text-muted-foreground">
                <badge.icon className="w-5 h-5" />
                <span className="text-sm font-medium">{badge.label}</span>
              </div>
            ))}
          </motion.div>

          {/* Stats */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.2 }}
            className="flex items-center gap-8"
          >
            {stats.map((stat, i) => (
              <div key={i} className="text-center">
                <p className="text-2xl font-bold font-heading text-foreground">{stat.value}</p>
                <p className="text-xs text-muted-foreground">{stat.label}</p>
              </div>
            ))}
          </motion.div>
        </div>
      </div>
    </section>
  );
}
